var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('myheader',{attrs:{"headTitle":_vm.headertitle}}),_c('div',{staticClass:"all_main backgroundC_white"},[_c('div',{staticClass:"all_content_padding"},[_c('div',{staticClass:"text14 textcolor333 margin_top_5",staticStyle:{"white-space":"pre-wrap","padding":".5rem"}},[_vm._v(" "+_vm._s(_vm.content)+" ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }